/**
 * Created with IntelliJ IDEA.
 * User: omerh
 * Date: 4/22/14
 * Time: 10:27 AM
 * To change this template use File | Settings | File Templates.
 */

define(function (require) {
    "use strict";

    var Marionette = require("marionette");
    var Template = require("templates/UpgradeAccountView.tmpl");
    var UpgradeAccountModel = require("models/UpgradeAccountModel");
    var Button = require("ui/button/Button");
    var Link = require("ui/link/Link");
    var Checkbox = require("ui/checkbox/Checkbox");
    var Translator = require("i18n/translator");
    var Logger = require("logger");
    var _ = require("underscore");
    var UpgradeAccountView;
    UpgradeAccountView = Marionette.ItemView.extend({
        template : Template,
        ui : {
            wrapper: ".upgrade-accout-wrapper",
            readButton: ".upgrade-account-link-container",
            checkbox: ".upgrade-account-checkbox",
            upgradeCPIButton: ".upgrade-account-cpi-button-container",
            upgradeSeatButton: ".upgrade-account-seat-button-container"
        },
        uiComponents: {
            readButton: {
                type: Link,
                options: {
                    text: Translator.translate("LEFramework.upgradeAccount.benefits.link.text"),
                    el: "view.ui.readButton",
                    permutation: Link.PERMUTATION.DEFAULT,
                    href: "https://kb.liveperson.com/portal/app/portlets/results/viewsolution.jsp?solutionid=140427035121670"
                },
                events: {
                    click: "onReadButtonClicked"
                }
            },
            checkBox: {
                type: Checkbox,
                options: {
                    el: "view.ui.checkbox",
                    checked: false,
                    label: Translator.translate("LEFramework.upgradeAccount.disclaimer"),
                    permutation: Checkbox.PERMUTATION.A
                },
                events:{
                    "change": "onCheckboxChanged"
                }
            },
            upgradeCPIButton : {
                type: Button,
                options: {
                    text: Translator.translate("LEFramework.upgradeAccount.button.cpi"),
                    el: "view.ui.upgradeCPIButton",
                    permutation: Button.PERMUTATION.BTN_PRIMARY,
                    initState: Button.STATES.DISABLED
                },
                events: {
                    click: "onUpgradeButtonClicked"
                }
            },
            upgradeSeatButton : {
                type: Button,
                options: {
                    text: Translator.translate("LEFramework.upgradeAccount.button.seat"),
                    el: "view.ui.upgradeSeatButton",
                    permutation: Button.PERMUTATION.BTN_PRIMARY,
                    initState: Button.STATES.DISABLED
                },
                events: {
                    click: "onUpgradeButtonClicked"
                }
            }
        },
        initialize: function (options) {
            this.logger = Logger.getLogger("LEFramework");
            if (!this.isValidOptions(options)) {
                throw "UpgradeAccountView: invalid argument: options is illegal";
            }
            this.model = new UpgradeAccountModel({explanationText: Translator.translate("LEFramework.upgradeAccount.text")});
        },
        isValidOptions: function (options) {
            if (!options || !_.isObject(options)) {
                this.logger.error("invalid argument: options is illegal");
                this.logger.graph({name:"framework:upgradeAccountView:optionsInvalid"});
                return false;
            }

            return true;
        },
        onReadButtonClicked: function () {
            this.logger.info("onReadButtonClicked");
        },
        onUpgradeButtonClicked: function (type) {
            var isCPI=  type === "upgradeCPIButton";
            this.logger.info("onUpgradeButtonClicked");
            LE.vent.trigger("migration:upgradeButtonClick", isCPI);
        },
        onCheckboxChanged: function () {
            this.logger.info("onCheckboxChanged");
            if (LE.sessionManager.isLPA()) {
                this.uiComponents.upgradeCPIButton.toggleState();
                this.uiComponents.upgradeSeatButton.toggleState();
            }else{
                LE.notifier.showError(Translator.translate("LEFramework.upgradeAccount.unauthorized.adminOnly"));
            }
        }
    });
    return UpgradeAccountView;
});
